import { useLocation, useParams } from "react-router-dom";
import Layout from "../components/Layout";
import { TransactionalReport } from "../components/_Reports/TransactionalReport";
import { StockAgeingReport } from "../components/_Reports/stockAgeingReport";
import { PaymentReports } from "../components/_Reports/PaymentsReport";
import { StockOrders } from "../components/_Reports/pvcStockOrderReport";
import InventoryOnHand from "../components/_Reports/inventoryOnHandReport";
import { StockInReport } from "../components/_Reports/stockInReport";
import SalesReport from "../components/_Reports/salesReport/salesReport";
import DocumentsReport from "../components/_Reports/documentReport";
import { StockReport } from "../components/_Reports/stockReport";
import { SkycTransactions } from "../components/_Reports/shortKycTransactionReport";
import { StockOutReport } from "../components/_Reports/stockOutReport";


const ReportsPage = (props: any) => {
    const location = useLocation();
    const pathname = location.pathname;

    // Extract the report type from the pathname
    // const reportType = pathname.split('/').pop(); // Assuming the URL is like /report/transaction
    const pathSegments = pathname.split('/').filter(segment => segment); // ['reports', 'transaction']
    const reportType = pathSegments[pathSegments.length - 1]; // 'transaction'

    let ReportComponent;

    switch (reportType) {
        case 'transactionalReport':
            ReportComponent = TransactionalReport;
            break;
        case 'stockAgeingReport':
            ReportComponent = StockAgeingReport;
            break;
        case 'paymentsReport':
            ReportComponent = PaymentReports;
            break;
        case 'stockOrdersReport':
            ReportComponent = StockOrders;
            break;
        case 'inventoryOnHandReport':
            ReportComponent = InventoryOnHand;
            break;
        case 'stockInReport':
            ReportComponent = StockInReport;
            break;
        case 'stockOutReport':
            ReportComponent = StockOutReport;
            break;
        case 'salesReport':
            ReportComponent = SalesReport;
            break;
        case 'documentReport':
            ReportComponent = DocumentsReport;
            break;
        case 'stockReport':
            ReportComponent = StockReport ;
            break;
        case 'skycReport':
            ReportComponent = SkycTransactions ;
            break;
            
        default:
            ReportComponent = () => <div>Report not found</div>;
    }

    return (
        <Layout>
            <ReportComponent />
        </Layout>
    );
};

export default ReportsPage;